import { escapeCssString } from "./escape-css-string";

interface PageBackgroundBranding {
  backgroundColor?: string | null;
  backgroundImageUrl?: string | null;
}

export function buildPageBackgroundCssRules(
  s: string,
  branding: PageBackgroundBranding | null | undefined,
): string[] {
  const color = branding?.backgroundColor;
  const imageUrl = branding?.backgroundImageUrl;
  if (!color && !imageUrl) {
    return [];
  }

  const declarations: string[] = [];
  if (color) {
    declarations.push(`background-color: ${color};`);
  }
  if (imageUrl) {
    // Escape the URL before interpolation — without this, a crafted value
    // like `") } body * { background: url(...) } /*` would close the url()
    // token and inject arbitrary rules into every customer session.
    declarations.push(
      `background-image: url("${escapeCssString(imageUrl)}");`,
      "background-size: cover;",
      "background-position: center;",
      "background-repeat: no-repeat;",
      "background-attachment: fixed;",
    );
  }
  return [`${s}[data-ui="portal-page-wrapper"] { ${declarations.join(" ")} }`];
}
